<template>
  <div>
    <div class="loading" v-if="isLoading == true">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <b-row class="mb-3" v-if="$can('export_partner_transaction')">
      <b-col class="d-flex align-items-start justify-content-start" cols="6">
        <!-- Generate by CRON -->
        <div class="d-flex align-items-center justify-content-start p-0" sm>
          <b-dropdown
            id="dropdown-left"
            variant="success"
            class="my-2 mr-3"
            :disabled="isLoadingButton.cron || !isParams"
          >
            <template #button-content>
              <div
                class="d-inline-flex sk-three-bounce custom-loading-bounce"
                v-if="isLoadingButton.cron"
              >
                <div class="sk-child sk-bounce1"></div>
                <div class="sk-child sk-bounce2"></div>
                <div class="sk-child sk-bounce3"></div>
              </div>
              <span class="mr-2" v-else>Generate report by CRON</span>
            </template>

            <b-dropdown-item @click="handleGenerate('CRON', 'CSV')">
              as CSV
            </b-dropdown-item>
            <b-dropdown-item @click="handleGenerate('CRON', 'XLSX')">
              as XLSX
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <!-- Generate by API -->
        <div class="d-flex align-items-center justify-content-start p-0" sm>
          <b-dropdown
            id="dropdown-left"
            variant="success"
            class="my-2 mr-3"
            :disabled="isLoadingButton.api || !isParams"
          >
            <template #button-content>
              <div
                class="d-inline-flex sk-three-bounce custom-loading-bounce"
                v-if="isLoadingButton.api"
              >
                <div class="sk-child sk-bounce1"></div>
                <div class="sk-child sk-bounce2"></div>
                <div class="sk-child sk-bounce3"></div>
              </div>
              <span class="mr-2" v-else>Generate report by API</span>
            </template>

            <b-dropdown-item @click="handleGenerate('API', 'CSV')">
              CSV
            </b-dropdown-item>
            <b-dropdown-item @click="handleGenerate('API', 'XLSX')">
              XLSX
            </b-dropdown-item>
          </b-dropdown>
          <b-badge class="badge-info-generate" v-show="count > 0">
            <p class="badge-info-count">
              {{ count }}
            </p>
            <p>
              <strong>Report is being processed,</strong> check the
              <router-link :to="{ name: 'Report Transaction History' }">
                Report Transaction History
              </router-link>
              menu periodically to download the file.
            </p>
          </b-badge>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <!-- Type Transaction -->
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search By Type Transaction"
            label-for="sp"
          >
            <b-form-select
              id="sp"
              v-model="type"
              :options="[
                { text: 'Search Transaction By...', value: '' },
                { text: 'Beli Emas', value: 1 },
                { text: 'Jual Emas', value: 2 },
                { text: 'Cetak Emas', value: 6 },
                { text: 'Transfer Emas', value: 9 }
              ]"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </b-col>
      <!-- Partner -->
      <b-col sm>
        <div>
          <b-form-group class="mb-3" label="Search By Partner" label-for="sp">
            <b-form-select
              id="sp"
              v-model="filterPartner"
              :options="partnerOptions"
            ></b-form-select>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <!-- Notify Date -->
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Notify Date"
            label-for="notify-daterange"
            :state="notifyDateRangeState === false ? false : computedDateRequiredState"
          >
            <template #invalid-feedback>
              <span v-if="notifyDateRangeState === false">The date range must be at least 1 hour</span>
              <span v-else-if="computedDateRequiredState === false">Date filter is required when using category filters (Type or Partner) without specific search</span>
            </template>
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <range-picker
                id="notify-daterange"
                name="notify-daterange"
                :start="notifyStartDate"
                :end="notifyEndDate"
                :type="'clear'"
                :disable="false"
                :autoUpdate="false"
                :timePicker="true"
                @picker="doDateFilter($event, 'NOTIFY')"
              >
              </range-picker>
              <b-input-group-append>
                <b-button
                  type="button"
                  variant="secondary"
                  @click="resetDateFilter('NOTIFY')"
                  >Reset</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
      <!-- Transaction Date -->
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Transaction Date"
            label-for="transaction-daterange"
            :state="dateRangeState === false ? false : computedDateRequiredState"
          >
            <template #invalid-feedback>
              <span v-if="dateRangeState === false">The date range must be at least 1 hour</span>
              <span v-else-if="computedDateRequiredState === false">Date filter is required when using category filters (Type or Partner) without specific search</span>
            </template>
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <range-picker
                id="transaction-daterange"
                :start="startDate"
                :end="endDate"
                :type="'clear'"
                :disable="false"
                :autoUpdate="false"
                :timePicker="true"
                @picker="doDateFilter($event, 'TRANSACTION')"
              >
              </range-picker>
              <b-input-group-append>
                <b-button
                  type="button"
                  variant="secondary"
                  @click="resetDateFilter('TRANSACTION')"
                  >Reset</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <!-- Search -->
      <b-col cols="6">
        <div>
          <b-form-group
            class="mb-3"
            label="Search"
            label-for="search"
            description="Searchable : Name, Email, Phone, Invoice No, Referral Code..."
          >
            <b-input-group>
              <b-form-input
                id="search"
                type="search"
                v-model="filterText"
                placeholder="Name, Email, Phone, Invoice No, Referral Code..."
              >
              </b-form-input>
              <b-input-group-append>
                <b-button
                  variant="secondary"
                  @click="resetFilter"
                  type="button"
                >
                  Reset
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <b-button
          :disabled="stateButton"
          :style="buttonStyle"
          class="mb-2"
          @click="doFilter"
        >
          Apply Filter
        </b-button>
        <p class="mb-3" :style="{ color: 'rgba(115, 129, 143, 1)' }">
          Click button 'Apply Filter' to apply the filter
        </p>
      </b-col>
    </b-row>
    <div v-if="isLoadingTable">
      <b-skeleton-table
        :rows="10"
        :columns="12"
        :table-props="{ bordered: true }"
      ></b-skeleton-table>
    </div>
    <vuetable
      v-else
      ref="vuetable"
      :api-mode="false"
      :fields="fields"
      :per-page="limit"
      :data-manager="dataManager"
      pagination-path="pagination"
      :no-data-template="isParams ? defaultTemplate : noDataTemplate"
      @vuetable:pagination-data="onPaginationData"
    >
      <template slot="name-slot" slot-scope="prop">
        <router-link
          :to="onAction('view-user', prop.rowData, prop.rowIndex)"
          target="_blank"
          >{{ prop.rowData.users.name }} ({{
            prop.rowData.users.email
          }})</router-link
        >
        <span></span>
      </template>
      <template slot="type-slot" slot-scope="prop">
        <span>{{ prop.rowData.transaction_type }}</span>
      </template>
      <template slot="treasury_invoice-slot" slot-scope="prop">
        <span>{{ prop.rowData.invoice_number }}</span>
      </template>
      <template slot="partner_invoice-slot" slot-scope="prop">
        <span>{{ prop.rowData.partner_invoice }}</span>
      </template>
      <template slot="commission-slot" slot-scope="prop">
        <span>{{ prop.rowData.commission }} </span>
      </template>
      <template slot="gold_amount-slot" slot-scope="prop">
        <span>{{ prop.rowData.gold_amount }} </span>
      </template>
      <template slot="amount-slot" slot-scope="prop">
        <span>{{ prop.rowData.amount }} </span>
      </template>
      <template slot="status-slot" slot-scope="prop">
        <span>{{ prop.rowData.status }} </span>
      </template>
      <template slot="buying_rate-slot" slot-scope="prop">
        <span>{{ prop.rowData.buying_rate }} </span>
      </template>
      <template slot="selling_rate-slot" slot-scope="prop">
        <span>{{ prop.rowData.selling_rate }} </span>
      </template>
      <template slot="actions-slot" slot-scope="prop">
        <div class="custom-actions" v-if="$can('detail_partner_transaction')">
          <button
            class="btn btn-success"
            @click="onAction('detail-item', prop.rowData)"
          >
            Detail
          </button>
        </div>
      </template>
    </vuetable>
    <div
      v-show="isParams"
      class="vuetable-pagination ui basic segment grid"
    >
      <div class="wrapper-pagination-custom">
        <div class="pagination-custom-info">
          <p>{{ this.paginationInfo }}</p>
        </div>
        <div class="pagination-custom-button">
          <button :disabled="currentPage === 1" @click="doMovePage('first')">
            <i
              v-if="currentPage === 1"
              class="fa fa-angle-double-left disabled"
            ></i>
            <i v-else class="fa fa-angle-double-left"></i>
          </button>
          <button :disabled="currentPage === 1" @click="doMovePage('prev')">
            <i v-if="currentPage === 1" class="fa fa-angle-left disabled"></i>
            <i v-else class="fa fa-angle-left"></i>
          </button>
          <div>{{ this.currentPage }}</div>
          <button :disabled="data.length < 10" @click="doMovePage('next')">
            <i v-if="data.length < 10" class="fa fa-angle-right disabled"></i>
            <i v-else class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import _ from "lodash";
import moment from "moment";

let startDate = "";
let endDate = "";
// eslint-disable-next-line no-unused-vars
let notifyStartDate = "";
// eslint-disable-next-line no-unused-vars
let notifyEndDate = "";
Vue.use(Vuetable);

export default {
  components: {
    Vuetable
  },
  prop: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data() {
    return {
      count: 0,
      page: 1,
      currentPage: 1,
      paginationInfo: "",
      limit: 10,
      data: [],
      startDate: "",
      endDate: "",
      notifyStartDate: "",
      notifyEndDate: "",
      type: "",
      filterText: "",
      filterPartner: "",
      dateRangeState: null,
      notifyDateRangeState: null,
      dateRequiredState: null,
      isLoading: false,
      isLoadingTable: false,
      isLoadingButton: {
        api: false,
        cron: false
      },
      cryptoOption: "",
      errors: {
        code: "",
        message: "",
        status: ""
      },
      typeOptions: [
        { value: "", text: "All" },
        { value: "beli_asset", text: "Beli Asset" },
        { value: "jual_asset", text: "Jual Asset" },
        { value: "top_up", text: "Top Up" },
        { value: "withdraw", text: "Withdraw" }
      ],
      partnerOptions: [{ value: "", text: "Select Partner" }],
      apiUrl:
        process.env.VUE_APP_SECRET +
        process.env.VUE_APP_CONFIG +
        `partner-transaction`,
      HttpOptions: {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      },
      sort: "partner_gold_transaction.created_at|desc",
      sortOrder: [
        {
          field: "partner_gold_transaction.created_at",
          sortField: "partner_gold_transaction.created_at",
          direction: "desc"
        },
        {
          field: "name-slot",
          sortField: "partner_gold_transaction.partner_name",
          direction: "desc"
        }
      ],
      moreParams: {},
      fields: [
        {
          name: "notify_date",
          sortField: "partner_gold_transaction.notify_date",
          title: "Notify Date"
        },
        {
          name: "created_at",
          sortField: "partner_gold_transaction.created_at",
          title: "Transaction Date"
        },
        {
          name: "name-slot",
          sortField: "partner_gold_transaction.partner_name",
          title: "User"
        },
        {
          name: "type-slot",
          title: "Transaction Type"
        },
        {
          name: "partner_name",
          title: "Partner"
        },
        {
          name: "treasury_invoice-slot",
          title: "Treasury Invoice No."
        },
        {
          name: "partner_invoice-slot",
          title: "Partner Invoice No."
        },
        {
          name: "gold_amount-slot",
          title: "Gold Amount"
        },
        {
          name: "amount-slot",
          title: "IDR Amount"
        },
        {
          name: "commission-slot",
          title: "Commission"
        },
        {
          name: "status-slot",
          title: "Transaction Status"
        },
        {
          name: "buying_rate-slot",
          title: "Gold Buy Pricee"
        },
        {
          name: "selling_rate-slot",
          title: "Gold Sell Price"
        },
        {
          name: "actions-slot",
          title: "Actions",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      paginationData: {
        current_page: 1,
        from: 1,
        last_page: 20,
        first_page_url:
          "http://development-183113.api.treasury.id/admin/v1/partner-transaction?sort=partner_gold_transaction.created_at%7Cdesc&page=1&per_page=10",
        next_page_url:
          "http://development-183113.api.treasury.id/admin/v1/partner-transaction?sort=partner_gold_transaction.created_at%7Cdesc&page=2&per_page=10",
        prev_page_url:
          "http://development-183113.api.treasury.id/admin/v1/partner-transaction?sort=partner_gold_transaction.created_at%7Cdesc&page=1&per_page=10",
        path: null,
        per_page: 10,
        to: 10,
        total: 1000
      },
      noDataTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center" style="height: 120px;"><p>Use filter to show your data.</p></div>',
      defaultTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center flex-column" style="height: 120px;"><p><strong>No results found.</strong></p><p>Please adjust your filter or search keywords</p></div>'
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    data(newVal, oldVal) {
      if (
        this.$refs.vuetable &&
        typeof this.$refs.vuetable.refresh === "function"
      ) {
        this.$refs.vuetable.refresh();
      }
    },
  },
  computed: {
    computedDateRequiredState() {
      // Check if category filters (type or partner) are filled
      const hasCategoryFilter = this.type !== "" || this.filterPartner !== "";
      const hasDateFilter = this.startDate !== "" || this.endDate !== "" || this.notifyStartDate !== "" || this.notifyEndDate !== "";
      const hasFreetextFilter = this.filterText !== "";
      
      // Rule 3: If freetext is filled, date is not required (overrides rule 1)
      if (hasFreetextFilter) {
        return null;
      }
      
      // Rule 1: If has category filter but no date, show error
      if (hasCategoryFilter && !hasDateFilter) {
        return false;
      }
      
      return null;
    },
    stateButton() {
      const allFiltersEmpty = [
        this.type, this.filterPartner, this.filterText, this.startDate, this.endDate, this.notifyStartDate, this.notifyEndDate
      ].every((f) => f === "")
      
      // If all filters are empty, disable button
      if (allFiltersEmpty) return true;
      
      // Disable if there's a date range validation error
      if (this.dateRangeState === false || this.notifyDateRangeState === false) return true;
      
      // Check filter types
      const hasCategoryFilter = this.type !== "" || this.filterPartner !== "";
      const hasDateFilter = this.startDate !== "" || this.endDate !== "" || this.notifyStartDate !== "" || this.notifyEndDate !== "";
      const hasFreetextFilter = this.filterText !== "";
      
      // Rule 2 & 3: If freetext is filled, date is not required
      if (hasFreetextFilter) {
        return false;
      }
      
      // Rule 1: If has category filter without freetext, date is required
      if (hasCategoryFilter && !hasDateFilter) {
        return true;
      }
      
      // Enable button if has valid filters
      return false;
    },
    buttonStyle() {
      return {
        background: !this.stateButton ? "#7565F6" : "#c8ced3",
        color: !this.stateButton ? "#FFFFFF" : "inherit"
      };
    },
    isParams() {
      const params =
        // eslint-disable-next-line no-unused-vars
        Object.entries(this.moreParams).filter(([key, value]) => value)
          .length == 0;

      return !params && !this.isLoadingTable;
    }
  },
  created() {
    this.onFetchNotification();
    this.$events.$on("apply-filter", this.onFilterSet);
    this.$events.$on("filter-reset", this.onFilterReset);
    this.$events.$on("movePage", this.onMovePage);
    this.$events.$on("date-filter-reset", this.onDateFilterReset);

    this.$http.get(`partner-list`).then(response => {
      const newPartner = response.data.map(item => {
        return { value: item.id, text: item.name };
      });
      this.partnerOptions = [...this.partnerOptions, ...newPartner];
    });
  },
  beforeDestroy() {
    this.$events.$off("apply-filter", this.onFilterSet);
    this.$events.$off("filter-reset", this.onFilterReset);
    this.$events.$off("movePage", this.onMovePage);
    this.$events.$off("date-filter-reset", this.onDateFilterReset);
  },
  methods: {
    onFetchNotification() {
      this.$http
        .get("report-transaction/on-process-count/partner")
        .then(response => {
          const countProgress = response.data.data.on_process_count;
          this.count = countProgress;

          // if (countProgress > 0) {
          //   setTimeout(() => {
          //     this.count = 0;
          //   }, 60000);
          // }
        })
        .catch(err => {
          this.handleLoadError(err);
        });
    },
    onFetch() {
      this.isLoadingTable = true;
      const newParams = Object.entries(this.moreParams)
        // eslint-disable-next-line no-unused-vars
        .filter(([key, value]) => value !== '' && value != null)
        .map(
          ([key, value]) =>
            `${
              key == "notifyStartDate"
                ? "notify_start_date"
                : key == "notifyEndDate"
                ? "notify_end_date"
                : key
            }=${value}`
        )
        .join("&");

      this.$http
        .get(
          `partner-transaction?sort=${encodeURIComponent(this.sort)}&page=${this.page}&per_page=10${newParams ? `&${newParams}` : ""}`
        )
        .then(response => {
          const datas = response.data.data;
          const datasCount = datas.length;
          const startIndex = (response.data.current_page - 1) * this.limit;
          const endIndex = Math.min(
            startIndex + this.limit,
            datasCount > 0 ? datasCount + startIndex : this.limit
          );

          this.data = datas;
          this.currentPage = response.data.current_page;
          this.paginationInfo =
            datasCount > 0
              ? `Displaying ${startIndex + 1} to ${endIndex}`
              : "No relevant data";

          this.isLoadingTable = false;
        })
        .catch(err => {
          this.isLoadingTable = false;
          this.handleLoadError(err);
        });
    },
    doMovePage(value) {
      this.$events.$emit("movePage", value);
    },
    onAction(action, data) {
      if (action == "view-user") {
        return { name: "Detail End User", params: { id: btoa(data.users.id) } };
      } else if (action == "detail-item") {
        const routeData = this.$router.resolve({
          name: "Detail Partner Transaction",
          params: { id: btoa(data.id) }
        });
        window.open(routeData.href, "_blank");
      }
    },
    npwpVal(value) {
      return value != null ? value : "-";
    },
    doFilter() {
      this.$events.$emit("apply-filter");
    },
    resetFilter() {
      this.filterText = "";
    },
    exportTable() {
      this.isLoading = true;
      if (this.startDate != "" && this.endDate != "") {
        startDate = this.startDate;
        endDate = this.endDate;
      } else {
        endDate = this.$setDate.format("YYYY-MM-DD HH:mm");
        startDate = this.$setDate
          .subtract(6, "days")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm");
      }

      const start = moment(startDate).format("YYYY-MM-DD HH:mm");
      const end = moment(endDate).format("YYYY-MM-DD HH:mm");

      this.$http
        .get(
          `partner-transactions?startDate=${start}&endDate=${end}&filter=${encodeURIComponent(
            this.filterText
          )}&type=${this.type}&partner=${this.filterPartner}`
        )
        .then(result => {
          this.isLoading = false;
          const exportPath = result.data.meta.data;
          window.location.href = exportPath;
        })
        .catch(error => {
          if (error.response) {
            this.isLoading = false;
            this.errors.code = error.response.status;
            this.errors.status = error.response.data.meta.code;
            this.errors.headers = error.response.headers;
          }
        });
    },
    handleLoadError(error) {
      const code = error.response.data.meta.code;
      const message = error.response.data.meta.message;

      this.errors.code = code;
      this.errors.message = message;
      this.errors.status = code;
      this.isLoading = false;
      this.isLoadingTable = false;
      this.isLoadingButton = false;

      if (this.errors.code == 401) {
        this.$swal
          .fire(
            "Your session expired!",
            "Your session has expired. Please login again to access this page!",
            "error"
          )
          .then(() => {
            this.$router.push("/login");
          });
      } else if (this.errors.code == 403) {
        this.$router.push("/403");
      } else if (this.errors.code == 500) {
        this.$router.push("/500");
      } else {
        this.$swal.fire("An error occured", message, "error").then(() => {
          this.$router.reload();
        });
      }
    },
    resetDateFilter(type) {
      this.$events.$emit("date-filter-reset", type);
    },
    allcap(value) {
      return value.toUpperCase();
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onPaginationData(paginationData) {
      console.log("paginationData", paginationData);
      // this.$refs.pagination.setPaginationData(paginationData)
      // this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    async onFilterSet() {
      this.page = 1;
      this.moreParams = {
        type: this.type,
        partner: this.filterPartner,
        filter: encodeURIComponent(this.filterText),
        start_from: this.startDate,
        end_to: this.endDate,
        notifyStartDate: this.notifyStartDate,
        notifyEndDate: this.notifyEndDate
      };
      this.onFetch();
    },
    doDateFilter(value, type) {
      const startDate = moment(value.startDate);
      const endDate = moment(value.endDate);
      
      // Calculate the difference in hours (with decimal precision)
      const hoursDiff = endDate.diff(startDate, 'hours', true);
      
      // Must be at least 1 hour difference
      if (hoursDiff < 1) {
        if (type == "TRANSACTION") {
          this.dateRangeState = false;
        } else {
          this.notifyDateRangeState = false;
        }
        return;
      }
      
      // Valid range - at least 1 hour
      if (type == "TRANSACTION") {
        this.dateRangeState = null;
        this.startDate = startDate.format("YYYY-MM-DD HH:mm");
        this.endDate = endDate.format("YYYY-MM-DD HH:mm");
      } else {
        this.notifyDateRangeState = null;
        this.notifyStartDate = startDate.format("YYYY-MM-DD HH:mm");
        this.notifyEndDate = endDate.format("YYYY-MM-DD HH:mm");
      }
    },
    async onFilterReset() {
      this.page = 1;
      this.moreParams = Object.fromEntries(
        Object.entries(this.moreParams).filter(([key]) => key !== "filter")
      );
      this.onFetch();
    },
    onMovePage(eventData) {
      if (eventData === "first") {
        this.page = 1;
        this.onFetch();
      } else if (eventData === "prev") {
        this.page--;
        this.onFetch();
      } else {
        this.page++;
        this.onFetch();
      }
    },
    dataManager(sortOrder, pagination) {
      let local = this.data;

      if (sortOrder.length > 0) {
        const newSort = `${sortOrder[0].sortField}|${sortOrder[0].direction}`;

        if (this.sort !== newSort) {
          this.sort = newSort;
          this.onFetch();
        }
      }

      pagination = this.$refs.vuetable.makePagination(local.length, this.limit);

      let from = pagination.from - 1;
      let to = from + this.limit;

      return {
        pagination: pagination,
        data: local.length > 0 ? _.slice(local, from, to) : []
      };
    },
    onDateFilterReset(type) {
      if (type == "TRANSACTION") {
        this.startDate = "";
        this.endDate = "";
        this.dateRangeState = null;
      } else {
        this.notifyStartDate = "";
        this.notifyEndDate = "";
        this.notifyDateRangeState = null;
      }
    },
    handleGenerate(type, ext) {
      this.isLoadingButton = {
        api: type === "API",
        cron: type === "CRON"
      };

      const newParams = Object.entries(this.moreParams)
        // eslint-disable-next-line no-unused-vars
        .filter(([key, value]) => value !== '' && value != null)
        .map(
          ([key, value]) =>
            `${
              key == "start_from"
                ? "startDate"
                : key == "end_to"
                ? "endDate"
                : key
            }=${value}`
        )
        .join("&");

      this.$http
        .get(
          `partner-transactions?sort=${encodeURIComponent(this.sort)}&generateBy=${type.toLowerCase()}&fileFormat=${ext.toLowerCase()}${
            newParams ? `&${newParams}` : ""
          }`
        )
        .then(result => {
          const countProgress = result.data.meta.data.on_process_count;
          this.count = countProgress;

          this.isLoadingButton = {
            api: false,
            cron: false
          };
        })
        .catch(error => {
          this.isLoadingButton = {
            api: false,
            cron: false
          };
          this.handleLoadError(error);
        });
    }
  },
};
</script>
<style>
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

/* Pagination Custom */
.wrapper-pagination-custom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
}

.pagination-custom-button {
  display: flex;
}

.pagination-custom-button button {
  width: 28px;
  height: 47px;
  padding: 13px 16px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
}

.pagination-custom-button button:first-child {
  padding: 13px 16px 13px 30px;
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px;
}

.pagination-custom-button button:nth-child(2),
.pagination-custom-button button:last-child {
  font-size: 1.3em;
  border-width: 1px;
}

.pagination-custom-button button:last-child {
  border-radius: 0 4px 4px 0;
}

.pagination-custom-button button i.disabled {
  opacity: 0.6;
}

.pagination-custom-button div {
  width: 28px;
  height: 47px;
  font-size: 1em;
  font-weight: 500;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
  border-width: 1px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Skeleton */
.skeleton-button,
.skeleton-type,
.skeleton-wrapper {
  margin-bottom: 20px;
}

.skeleton-title {
  height: 18px;
  margin-bottom: 10px;
}

.skeleton-filter {
  margin-right: 30px;
}

.skeleton-wrapper {
  display: grid;
  grid-template-columns: auto auto;
}

.badge-info-generate {
  height: 32px;
  padding: 8px 12px;
  background-color: #fff3d3;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-info-count {
  width: 18px;
  height: 18px;
  margin: 0 6px 0 0;
  background-color: #ffce50;
  border-radius: 100px;
}

.custom-loading-bounce {
  width: 72px !important;
  height: 18px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.custom-loading-bounce .sk-child {
  width: 6px !important;
  height: 6px !important;
  background: #ffffff !important;
}
</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
